export const useStyles = makeStyles((theme) => ({
  formContainer: {
    padding: 0,
  },
  formField: {
    padding: '5px 5px 25px 5px',
  },
  sectionTitle: {
    padding: '5px 10px',
  },
  muiEditor: {
    padding: '5px 5px 0 5px',
  },
  emailSigContainer: {
    padding: '0 5px 20px 5px',
  },
  emailSig: {
    padding: '0 20px 24px 20px',
    background: 'white',
    borderStyle: 'solid',
    borderWidth: '0 1px 1px 1px',
    borderColor: '#c6cfd9',
  },
}))
